import cn from '../modules/cn'

function Card({ className, ...props }) {
  return (
    <div
      className={cn('bg-white shadow border-b border-gray-200 sm:rounded-lg', className)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  )
}

Card.propTypes = {
  className: cn.propType,
}

Card.defaultProps = {
  className: null,
}

export default Card
